import VenueSheetContent from "@/components/VenueDetailBasic/VenueSheetContent";
import { useCustomToast } from "@/hooks/useCustomToast";
import { useDarkMode } from "@/hooks/useDarkMode";
import { useGeoLocation } from "@/hooks/useGeoLocation";

import { useVenueDetailsBySlug, useAuth } from "common/hooks";
import { Venue } from "common/types";
import React, { useEffect } from "react";
import { ThreeDots } from "react-loader-spinner";
import { Storage } from "common/storage";

function VenueDetailBasics(props: {
  selectedVenue: Venue;
  onBack: () => void;
  openAllPhotosInline?: boolean;
  onOpenAllPhotos?: () => void;
  currentVenueTypePage?: number;
  onShowDetailView?: (initialSpaceId: string) => void;
  onShowPhotosDetailView?: (initialCategoryId: number | null) => void;
}) {
  const isDark = useDarkMode();
  const { location } = useGeoLocation();
  const { isLoggedIn } = useAuth();

  const showToast = useCustomToast();

  const { data, error, isLoading, refetch } = useVenueDetailsBySlug({
    slug: props.selectedVenue.business.slug,
    latitude: location?.latitude.toString(),
    longitude: location?.longitude.toString(),
    accessToken: Storage.getCurrentUserToken() || "",
    enabled: location ? true : false,
  });

  useEffect(() => {
    if (location) {
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (error) {
      showToast(error.message, "error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error, isDark]);

  if (!data || isLoading) {
    return (
      <div className="flex-1 h-full items-center justify-center flex">
        <div className="w-[80px] h-[50px] bg-white flex justify-center items-center rounded-full">
          <ThreeDots
            visible={true}
            height="35"
            width="35"
            color={isDark ? "#D3D3D9" : "#151A36"}
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      </div>
    );
  }
  return (
    <div className="h-full flex flex-col overflow-hidden">
      <VenueSheetContent
        venueDetailsResponse={data}
        onBack={props.onBack}
        onRefresh={() => {
          if (isLoggedIn) {
            setTimeout(() => refetch(), 1000);
          } else {
            // No need to refresh for non-logged-in users
          }
        }}
        fullSize={true}
        openAllPhotosInline={props.openAllPhotosInline}
        onOpenAllPhotos={props.onOpenAllPhotos}
        currentVenueTypePage={props.currentVenueTypePage}
        onShowDetailView={props.onShowDetailView}
        onShowPhotosDetailView={props.onShowPhotosDetailView}
      />
    </div>
  );
}

export default VenueDetailBasics;
